import React, { useState, useEffect } from "react";
import SwipeableViews from "react-swipeable-views";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Box, Tabs, Tab, TextField, Typography, Grid, IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GiCancel } from "react-icons/gi";

import SingleMaintenanceExcelToList from "./SingleMaintenanceExcelToList";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { FaUpload } from "react-icons/fa";
import GetAppIcon from "@mui/icons-material/GetApp";



import SingleMaintenanceTable from "../SingleMaintenance/SingleMaintenanceTable";
import { downloadSchema, uploadExcel, downloadExamples } from "../../store/actions/SingleMaintenanceUpdateActions";

function SingleMaintenanceUpdate() {
    const ls = localStorage;
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();

    const [singleMaintenanceExcel, setSingleMaintenanceExcel] = useState([]);

    const [warningList, setWarningList] = useState([]);
    const [hashCode, setHashCode] = useState("")
    const [plantId, setPlantId] = useState("")

    const [disableExcel, setDisableExcel] = useState(false);
    const [disableUpload, setDisableUpload] = useState(true);
    const [disableCancel, setDisableCancel] = useState(true)


    const { SingleMaintenanceUpdateReducer } = useSelector((state) => state);
    const [formData, setFormData] = useState(new FormData());

    const [openDialog, setOpenDialog] = useState(false);


    useEffect(() => {
        if (SingleMaintenanceUpdateReducer?.data) {
            setWarningList([]);
            setFormData(new FormData());
            setDisableUpload(true);
            setDisableExcel(false);
            setDisableCancel(true);
        }
        if (SingleMaintenanceUpdateReducer?.uploadResponse) {
            if(SingleMaintenanceUpdateReducer.uploadResponse.errorCode === 0) {
            setWarningList([]);
            setDisableCancel(true);
            setDisableExcel(false);
            setDisableUpload(true);
            window.location.reload();
            }
        }
    }, [SingleMaintenanceUpdateReducer]);

    useEffect(() => {
        setPlantId(ls.getItem("plantId"))
    },[])


    const TabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <Typography component="div" role="tabpanel" hidden={value !== index} id={`scrollable-auto-tabpanel-${index}`} aria-labelledby={`scrollable-auto-tab-${index}`} {...other}>
                <Box>{children}</Box>
            </Typography>
        );
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const cancelUpload = () => {
        setWarningList([]);
        setDisableCancel(true);
        setDisableExcel(false);
        window.location.reload();
    };



    const callBackTabData = (excelData) => {    
        if (excelData.excelList.errorCode === 0) {
            setSingleMaintenanceExcel(excelData?.excelList.resultObject.content);
            setDisableExcel(true);
            setDisableCancel(false);
            setDisableUpload(false);
            setHashCode(excelData.excelList.resultObject.fileChecksum.hash)

            if (excelData.excelList.resultObject.warnings?.length > 0) {
                setWarningList(excelData?.excelList.resultObject.warnings);
                setDisableUpload(true);
            }
        }
    };

    const a11yProps = (index) => {
        return {
            id: `scrollable-auto-tab-${index}`,
            "aria-controls": `scrollable-auto-tabpanel-${index}`,
        };
    };




    return (
        <div>
            <Grid container item md={12}>
                {/* Tabs */}
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Tabs value={value} onChange={handleChange} centered>
                        <Tab label={t("SingleMaintenanceUpdate")} {...a11yProps(0)} ></Tab>
                    </Tabs>
                </Grid>

                <Grid item xs={1} sm={3} md={4} lg={4}></Grid>

                {/* Buttons */}
                <Grid item xs={12} sm={6} md={4} lg={4}>
                    {/* Excel File Outline */}
                        <Tooltip title={t("ExcelFileOutline")}>
                            <IconButton
                                onClick={() =>
                                    dispatch(downloadSchema())
                                }
                                size="large">
                                <GetAppIcon style={{ color: "#008000", width: 50, height: 50 }} />
                            </IconButton>
                        </Tooltip>

                    {/* Excel Butonu */}
                    <Tooltip title={t("ChooseExcelFile")}>
                        <IconButton component="label" disabled={disableExcel} size="large">
                            <SingleMaintenanceExcelToList
                                callBackTabData={callBackTabData}
                                disableExcel={disableExcel}
                                setFormData={setFormData}
                            />
                        </IconButton>
                    </Tooltip>

                    {/* İptal Butonu */}
                    <Tooltip title={t("Cancel")}>
                        <IconButton component="label" onClick={cancelUpload} disabled={disableCancel} size="large">
                            <GiCancel style={{ width: 50, height: 50, padding: 0, fill: disableCancel ? "#bdbdbd" : "#E82114" }} />
                        </IconButton>
                    </Tooltip>

                    {/* Upload Butonu */}
                    <Tooltip title={t("DataUpload")}>
                        <IconButton component="label" disabled={disableUpload} size="large">
                            <FaUpload disableUpload={disableUpload} style={{ fill: disableUpload ? "#bdbdbd" : "#00a4b9", width: "50px", height: "50px", padding: "0px" }} onClick={ () => dispatch(uploadExcel(hashCode))
                                } />
                        </IconButton>
                    </Tooltip>

                      {/* Excel File Outline with examples*/}
                 
                </Grid>
                <Grid item xs={12} sm={3} md={4} lg={4}>
                    <Tooltip title={t("ExcelFileExampleOutline")}>
                        <IconButton
                            onClick={() =>
                                dispatch(downloadExamples(plantId))
                            }
                            size="large">
                            <GetAppIcon style={{ color: "#0000FF", width: 50, height: 50 }} />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>

            <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={value}
                onChangeIndex={(value) => {
                    setValue(value);
                }}
                enableMouseEvents
            >
                {/* callback function'dan gelen data ilgili komponente props olarak gidip tabloyu doldurur */}
                <TabPanel value={value} index={value} dir={theme.direction}>
                    <SingleMaintenanceTable singleMaintenanceExcel={singleMaintenanceExcel} warningList={warningList} />
                </TabPanel>
            </SwipeableViews>
            <LoadingBackdrop id="sm_lbd"/>
        </div>
    );
}

export default SingleMaintenanceUpdate;
